import CorteDeCaja from './CorteDeCaja';
export default CorteDeCaja;